import {
  AuthorsDocument,
  CategoriesDocument,
  CohortsDocument,
  GroupDocument,
  LibraryResourcesDocument,
  ManageResourceDocument,
  PathDocument,
  UserRegistrationsDocument
} from "../api/generated"
import GROUPS_QUERY from "../group/graphql/groups-query"
import { USER_RESOURCES_QUERY } from "../home/design/Design"

// Use this class to sync between apollo client
// and legacy/client stores.

// When a legacy/client store updates a
// resource, LegacyStoreBridge provides hooks
// to manually refetch or update the resource
// stored in apollo client.

// This is just a temporary solution while we
// update small pieces of the UI to use graphql.

// TODO: delete methods as legacy/client
// stores that use them are removed.
// Once legacy/client stores have been
// replaced this module can be removed.

class ApolloClientStoreBridge {
  constructor(client) {
    this.client = client
  }

  refetchResource(variables) {
    // requires id
    this.client.query({
      variables,
      query: ManageResourceDocument,
      fetchPolicy: "network-only"
    })
  }

  refetchAuthors(variables) {
    // requires school_id, first
    this.client.query({
      variables,
      query: AuthorsDocument,
      fetchPolicy: "network-only"
    })
  }

  refetchCategories(variables) {
    // requires school_id, first
    this.client.query({
      variables,
      query: CategoriesDocument,
      fetchPolicy: "network-only"
    })
  }

  refetchTeachingResources(variables) {
    this.client.query({
      query: CohortsDocument,
      fetchPolicy: "network-only"
    })
  }

  refetchLibraryResources() {
    this.client.query({
      variables: { first: 24 },
      query: LibraryResourcesDocument,
      fetchPolicy: "network-only"
    })
  }

  refetchGroup(variables) {
    // requires id
    this.client.query({
      variables,
      query: GroupDocument,
      fetchPolicy: "network-only"
    })
  }

  refetchGroups(variables) {
    // requires resource_id, first
    this.client.query({
      variables,
      query: GROUPS_QUERY,
      fetchPolicy: "network-only"
    })
  }

  refetchRegistrations(variables) {
    // requires id, progress_filter, role_filter
    this.client.query({
      variables,
      query: UserRegistrationsDocument,
      fetchPolicy: "network-only"
    })
  }

  refetchResources(variables) {
    this.client.query({
      variables,
      query: USER_RESOURCES_QUERY,
      fetchPolicy: "network-only"
    })
  }

  refetchPath(variables = {}) {
    // requires id
    this.client.query({
      variables: {
        first: 24,
        ...variables
      },
      query: PathDocument,
      fetchPolicy: "network-only"
    })
  }
}

export default ApolloClientStoreBridge
